<template>
  <div class="invite">
    <i class="el-icon-arrow-left" @click="back()" v-show="!slidePageStatus"></i>
    <el-scrollbar>
      <div class="titlebox">
        <img
          src="@/assets/sidebar/title-b24a3619.png"
          alt=""
          class="titleimg"
        />
        <img
          src="@/assets/sidebar/sub_title-0f328bf3.jpg"
          alt=""
          class="subtitleimg"
        />
      </div>
      <div class="msgbox">
        <div class="border left">
          <div class="profit">
            <p class="msgboxtitle">邀好友注册成功</p>
            <div>
              <p class="num">1</p>
			  人可获得
            </div>
			<p>视频生成10分钟</p>
          </div>
        </div>
		<!-- <div class="border left">
		  <div class="profit">
		    <p class="msgboxtitle">邀好友注册成功</p>
		    <div>
		      <p class="num">3</p>
		      <p>
		        <img src="@/assets/sidebar/down.png" alt="" />
		        <span>AI点</span>
		      </p>
		    </div>
		    <p>双方各得<span>点数奖励</span></p>
		  </div>
		</div> -->
        <div><i class="el-icon-plus"></i></div>
        <div class="border right">
          <div class="profit">
            <p class="msgboxtitle">邀请好友充值月会员</p>
            <div>
              可获得充值金额
              <span class="orange">30%</span>返利
            </div>
          </div>
        </div>
		<!-- <div class="border right">
          <div class="profit">
            <p class="msgboxtitle">好友首次购买会员</p>
            <div>
              <span class="num">20</span>
              <span class="orange">%</span>
            </div>
            <p>你可得买会员金额的</p>
          </div>
        </div> -->
      </div>

      <div class="rulesbox">
       <!-- <p>邀请好友注册，第一个好友赠送10分钟时长，从第二个开始赠送20元充值券</p>
       <p>邀请好友充值体验卡，赠送50元充值券</p>
       <p>邀请好友充值月卡，赠送100元充值券</p>
       <p>邀请好友充值年卡，即可直接兑换时长300分钟</p> -->
        <div @click="slidePageStatus = true">查看我的奖励</div>
      </div>

      <div class="tip">
        *累计获得100元充值券后，即可兑换40分钟时长，成功邀请充值年度会员即可直接兑换300分钟时长。
      </div>
	 <!-- <div class="tip">
        *如果达成10个被邀好友购买会员的条件，则从第11个起，返佣比例升级至25%；如果您有更多推广资源，可联系客服单独议价
      </div> -->

      <!-- <div class="activityBox">
        <p class="title">活动规则</p>
        <div class="content"> 
          <p>
            1.
            分享您的邀请链接给好友，当Ta通过链接注册成功后，您和Ta各获得3个AI点数
          </p>
          <p>
            2.
            好友首次购买Ai速创会员，您将获得Ta支付金额的20%佣金奖励；当购买人数超过10人后，第11人开始，佣金比例上调为25%
          </p>
          <p>3. 好友购买成功30天后方可提现，发生退款后收益无效</p>
          <p>4. 佣金收益超过30元，可联系客服申请提现</p>
          <p>5. 本活动长期有效，最终解释权归广州康桥信息技术有限公司所有</p>
        </div>
      </div> -->
    </el-scrollbar>

    <div class="fixed-bottom">
      <div @click="copy($event)">分享给好友</div>
    </div>

    <div class="slidePage" v-show="slidePageStatus">
      <div class="header">
        <i class="el-icon-arrow-left" @click="slidePageStatus = false"></i>
        <p :class="slidePageIndex ? 'this' : ''" @click="slidePageIndex = true">
          优惠券列表
        </p>
        <p
          :class="slidePageIndex ? '' : 'this'"
          @click="slidePageIndex = false"
        >
          我的邀请
        </p>
      </div>
      <div class="tip">数据并非实时更新，可能会有延后</div>
<!--      <div v-show="slidePageIndex" class="slidepage1">
        <div class="income">
          <div class="incomeheader">
            <p>
              <span>可提现收益</span>
              <span>好友购买30天后可提现</span>
            </p>
            <p>
              <span>￥</span><span>{{ income.income1 }}</span>
            </p>
          </div>
          <div class="incomebody">
            <ul>
              <li>
                <p>待确定收益</p>
                <p>0</p>
              </li>
              <li>
                <p>已提现收益</p>
                <p>0</p>
              </li>
              <li>
                <p>累计收益</p>
                <p>0</p>
              </li>
            </ul>
          </div>
          <div class="incomefooter">
            <p>可提现收益超过30元可申请提现</p>
            <p>提现</p>
          </div>
        </div> -->
		<el-table
			v-if="slidePageIndex && tableData1.length > 0"
			size="mini"
		    :data="tableData1"
		    style="width: 100%">
		    <el-table-column
		      prop="title"
		      label="优惠券名称"
		      >
		    </el-table-column>
		    <el-table-column
		      prop="face_value"
		      label="面额">
		    </el-table-column>
		   <el-table-column
			prop="status_text"
			label="状态">
		   </el-table-column>
		    <el-table-column
				 width="140px"
		      prop="create_time"
		      label="时间">
		    </el-table-column>
		  </el-table>
        <div v-if="slidePageIndex && tableData1.length == 0" class="empty">
          <img src="@/assets/sidebar/no_profit-8f5a7003.png" alt="" />
          <p>暂无记录，快去邀请好友吧</p>
        </div>
		<div v-show="!slidePageIndex">
				  <el-table
				  	size="mini"
					v-if="tableData2.length > 0"
				  	:data="tableData2"
				  	style="width: 100%">
				  	<el-table-column
				  	  prop="nickname"
				  	  label="昵称"
				  	  >
				  	</el-table-column>
				  	  </el-table-column>
				  	<el-table-column
				  		width="140px"
				  	  prop="createtime"
				  	  label="注册时间">
				  	</el-table-column>
				    </el-table>
		  <div v-if="tableData2.length == 0" class="empty">
		    <img src="@/assets/sidebar/no_profit-8f5a7003.png" alt="" />
		    <p>暂无记录，快去邀请好友吧</p>
		  </div>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import {getInviteList} from "@/api/user"
export default {
  data() {
    return {
	tableData1:[],
	tableData2:[],
      point:20,
      pointbox:true,
      invitebox:false,
      slidePageStatus:false,
      slidePageIndex:true,
      income:{
          income1:0,
          income2:0,
          income3:0,
          income4:0,
      }
    };
  },
  created() {
  	this.getInviteList();
  },
  methods: {
	  getInviteList() {
	  	getInviteList().then(res => {
	  		this.tableData1 = res.data.coupons;
	  		this.tableData2 = res.data.users;
	  	})
	  },
    back() {
      this.$router.back();
    },
    copy(event) {
        const clipboard = new Clipboard(event.target, {
            text: () => this.$store.userInfo.invite_text
        })
        clipboard.on('success', () => {
            clipboard.destroy()
            this.$message({
                message: '复制成功',
                type: 'success',
                duration: 1 * 1000
            })
        })
        clipboard.on('error', () => {
            clipboard.destroy()
            this.$message({
                message: '复制失败',
                type: 'error',
                duration: 1 * 1000
            })
        })
        clipboard.onClick(event)	
    },
  },
};
</script>

<style lang="less">
.invite {
  width: 100%;
  height: 95vh;
  padding: 60px 24px 110px;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(../../assets/sidebar/bg-a2358bbb.png);
  //   border-radius: 16px;
  overflow: hidden;
  z-index: 2001;
  position: relative;
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-icon-arrow-left {
    position: absolute;
    top: 8px;
    left: 8px;
    font-size: 30px;
    cursor: pointer;
    color: #1d2129;
    z-index: 2000;
  }
  .titlebox {
    img {
      display: block;
    }
    .titleimg {
      width: 254px;
      margin: 0 auto;
    }
    .subtitleimg {
      width: 300px;
      margin: 12px auto 0;
    }
  }
  .msgbox {
    display: flex;
    align-items: center;
    // padding: 0 20px;
    margin-top: 16px;
    justify-content: space-between;
    i {
      font-size: 18px;
      color: #fb8a45;
    }
    .border {
      height: 154px;
      width: calc(50% - 10px);
      background: #ffffff;
      border-radius: 12px;
      border: 2px solid #0c5cf8;
      box-shadow: 0 2.7004px 10.8016px rgba(98, 170, 252, 0.26);
      text-align: center;
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .left {
      .profit {
        div {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 10px 0;
          span {
            display: block;
            font-size: 13px;
            font-weight: 700;
            text-align: left;
          }
          img {
            display: block;
            width: 50px;
          }
        }
      }
    }
    .right {
      .profit {
        div {
          margin: 10px 0;
        }
        .orange {
          color: #f5663e;
        }
      }
    }
    .msgboxtitle {
      font-size: 16px;
      font-weight: 700;
    }
    .num {
      font-size: 40px;
      font-weight: 700;
      color: #f5663e;
    }
  }

  .rulesbox {
    margin: 20px 0 0;
    padding: 20px;
    width: 100%;
    //height: 240px;
	height: 120px;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: inset -4px -4px 13px rgba(51, 133, 255, 0.2),
      inset 4px 4px 13px rgba(51, 133, 255, 0.2);
    font-size: 14px;
    color: #233049;
    p {
      height: 32px;
      border-bottom: 1px dashed #e2e2e2;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    div {
      width: 160px;
      height: 48px;
      font-weight: 700;
      background: linear-gradient(180deg, #fdb96a -2.08%, #fd8039 110.94%);
      box-shadow: 0 2px 11px rgba(168, 115, 255, 0.15);
      border-radius: 48px;
      color: #fff;
      font-size: 16px;
      align-items: center;
      justify-content: center;
      margin: 14px auto 0;
      display: flex;
    }
  }

  .tip {
    color: #999;
    font-size: 10px;
    line-height: 14px;
    margin-top: 8px;
    text-align: center;
  }

  .activityBox {
    margin-top: 20px;
    width: 100%;
    padding: 20px;
    background-color: #fff;
    border-radius: 12px;
    text-align: left;
    .title {
      color: #101834;
      font-weight: 700;
      font-size: 14px;
    }
    .content {
      p {
        color: #666;
        font-size: 12px;
        line-height: 150%;
        margin-top: 8px;
      }
    }
  }

  .fixed-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 12px 20px 20px;
    background-color: #fff;
    div {
      color: #fff;
      background: linear-gradient(180deg, #3591fd 5.19%, #205efa 100%), #00c777;
      cursor: pointer;
      width: 100%;
      height: 52px;
      border-radius: 12px;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .slidePage {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1999;
    background-color: #fff;
    .header {
      height: 60px;
      background-color: #fff;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        padding: 0 16px;
        color: #333;
        font-size: 14px;
        position: relative;
        cursor: pointer;
      }
      .el-icon-arrow-left {
        position: absolute;
        top: 20px;
        left: 20px;
        font-size: 20px;
        cursor: pointer;
      }
      .this {
        color: #2d8af5;
        font-weight: 700;
      }
      .this::after {
        content: "";
        height: 2px;
        width: 40px;
        background: #2d8af5;
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -10px;
      }
    }
    .tip {
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f9f2ec;
      color: #d3895f;
      font-size: 12px;
    }
    .slidepage1 {
      background: #f4f5f7;
      color: #020713;
      height: calc(100% - 82px);
      padding: 16px 20px;
      .income {
        filter: drop-shadow(0px 0px 8px rgba(221, 84, 41, 0.2));
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        border: 1px solid rgba(255, 255, 255, 0.85);
        border-radius: 8px;
        background: linear-gradient(
          285.97deg,
          #ffd1a7 0.44%,
          #f7e9d5 70.2%,
          #f7e9d3 107.33%
        );
        margin-bottom: 16px;
        .incomeheader {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #fff;
          padding: 12px 0;
          margin: 0 20px;
          p:nth-child(1) {
            span {
              display: block;
            }
            span:nth-child(1) {
              color: #9a4438;
              font-size: 16px;
              font-weight: 700;
              margin-bottom: 2px;
            }
            span:nth-child(2) {
              color: #9a4438;
              font-size: 12px;
              line-height: 17px;
            }
          }
          p:nth-child(2) {
            color: #a21515;
            span:nth-child(1) {
              font-size: 12px;
              font-weight: 700;
            }
            span:nth-child(2) {
              font-size: 30px;
              font-weight: 700;
            }
          }
        }
        .incomebody {
          padding: 12px 20px;
          ul {
            display: flex;
            justify-content: space-between;
            text-align: center;
            li {
              flex: 0 0 33.3%;
              p:nth-child(1) {
                color: #825656;
                font-size: 12px;
                margin-bottom: 6px;
              }
              p:nth-child(2) {
                color: #825656;
                font-weight: 700;
                font-size: 20px;
              }
            }
          }
        }
        .incomefooter {
          height: 40px;
          background: rgba(255, 255, 255, 0.2);
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          p:nth-child(1) {
            color: #9a4438;
            font-size: 12px;
          }
          p:nth-child(2) {
            height: 28px;
            width: 64px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            font-weight: 700;
            color: #8a1d1d;
            background: #ffffff;
            border-radius: 18px;
          }
        }
      }
    }
  }
  .empty {
    margin-top: 80px;
    text-align: center;
    img {
      width: 70px;
    }
    p {
      text-align: center;
      margin-top: 16px;
      font-size: 12px;
      color: #999;
    }
  }
}
</style>